import type { ReactNode } from 'react';
import { RecordPicker } from './RecordPicker.js';
import { personLabel } from './ApprovalLevels.js';

interface UserOption {
  readonly userId: string;
  readonly displayName: string | null;
  readonly employeeCode: string | null;
}

interface Props {
  readonly label: string;
  readonly testId: string;
  readonly value: string;
  readonly onPick: (userId: string, label: string) => void;
}

/** A user of the caller's tenant, picked by name and employee code. */
export function UserPicker({ label, testId, value, onPick }: Props): ReactNode {
  return (
    <RecordPicker<UserOption>
      endpoint="/v1/users?limit=200"
      idField="userId"
      label={label}
      testId={testId}
      value={value}
      optionLabel={(u) => personLabel(u.displayName, u.employeeCode) ?? ''}
      onPick={onPick}
      emptyText="No user on file"
    />
  );
}
